import Vue from 'vue'
export const eventBus = new Vue()
export default {
  install (Vue, options) {
    Vue.prototype.$eventBus = eventBus
  }
}
